import React from "react";
import LinkIcon from "@mui/icons-material/Link";
import { IconButton } from "@mui/material";

interface AssociateMenuProps {
  checked: boolean;
  onClick?: () => void;
  width?: string;
  height?: string;
}

const AssociateMenu: React.FC<AssociateMenuProps> = ({
  checked,
  onClick,
  width = "24px",
  height = "24px",
}) => {
  return (
    <IconButton
      onClick={onClick}
      style={{
        backgroundColor: checked ? "#0A0C33" : "transparent",
        borderRadius: "6px",
        padding: 0,
        width: "36px",
        height: "36px",
        transition: "background-color 0.3s ease",
        border: "1px solid #0A0C33",
      }}
    >
      <LinkIcon
        style={{
          color: checked ? "#A5EB17" : "#0A0C33",
          width: width,
          height: height,
        }}
        sx={{ transform: "rotate(45deg)" }}
      />
    </IconButton>
  );
};

export default AssociateMenu;
